var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showContent === true)?_c('div',[_vm._t("default")],2):(_vm.showContent === false)?_c('div',{staticClass:"text-center mt-4"},[_vm._v(" You are not authorized to view this page. ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }